import { useEffect } from 'react';
import { IconsTabWrapper, TabText } from 'src/styles/button.style';
import ViolationListIconComponent from './ViolationListIcon';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import { StowageRuleViolationStatus } from 'src/enums/stowage/stowageRule/stowageRuleViolationStatus';

const ViolationListTab: React.FC = () => {
    const { filteredViolations } = useStowageSelectionStore();

    useEffect(() => {}, [filteredViolations]);

    const hardRuleViolationsCount = filteredViolations?.filter((o) => o.type === StowageRuleConsequenceType.HardRule).length || 0;
    const softRuleViolationsCount =
        filteredViolations?.filter((o) => o.type === StowageRuleConsequenceType.SoftRule && o.status !== StowageRuleViolationStatus.Accepted)
            .length || 0;

    return (
        <>
            <TabText>Violation List</TabText>
            <IconsTabWrapper>
                {hardRuleViolationsCount > 0 && (
                    <ViolationListIconComponent
                        violationType={StowageRuleConsequenceType.HardRule}
                        includeText={false}
                        count={hardRuleViolationsCount}
                    />
                )}
                {softRuleViolationsCount > 0 && (
                    <ViolationListIconComponent
                        violationType={StowageRuleConsequenceType.SoftRule}
                        includeText={false}
                        count={softRuleViolationsCount}
                    />
                )}
            </IconsTabWrapper>
        </>
    );
};

export default ViolationListTab;
